module.exports = __webpack_public_path__ + "static/media/erion-veliaj.e7af99b7.jpg";